import React from 'react';
import { useOrder } from '../../context/OrderContext';
import { getValidCarterCodes, normalizeProfileType } from '../../utils/formatters';

const CarterSelector = ({ selectedCode, onSelect }) => {
  const { state } = useOrder();
  const rawProfileType = state.orderDetails.profileType;
  const profileType = normalizeProfileType(rawProfileType);

  const validCarterCodes = getValidCarterCodes(profileType);

  const handleCarterSelect = (code) => {
    onSelect({
      hasCarter: code !== null,
      carterCode: code
    });
  };

  const handleNoCarterSelect = () => {
    onSelect({
      hasCarter: false,
      carterCode: null
    });
  };

  // Get the appropriate image filename based on profile and carter code
  const getCarterImagePath = (code) => {
    // Special case for 6 STADIO profile
    if (rawProfileType === '6S') {
      return `/images/carter/6S/SEL-N6S-${code}.png`;
    }
    // Special cases for certain profile/code combinations
    if (profileType === '116' && code === '1C') {
      return `/images/carter/116/SEL-NINFA116-1C.png`;
    }
    if (profileType === '56' && code === '1I') {
      return `/images/carter/56/SEL-NINFA56-1I.png`;
    }

    // Standard naming convention: /images/carter/{profileType}/SEL-N{profileType}-{code}.png
    return `/images/carter/${profileType}/SEL-N${profileType}-${code}.png`;
  };

  // Get label for carter code
  const getCarterLabel = (code) => {
    if (profileType === '176' || profileType === '186') {
      const labelMap = {
        '1I': 'Carter Grande',
        '1': 'Carter Piccolo',
        '2': 'Doppio Carter'
      };
      return labelMap[code] || `Carter ${code}`;
    }
    return `Carter ${code}`;
  };

  // If N50, we don't need to select carter
  if (profileType === '50') {
    return (
      <div className="text-center p-4">
        <h2 className="text-xl font-bold mb-4">Carter</h2>
        <p>Il profilo N50 non richiede la selezione del carter.</p>
        <button
          onClick={() => onSelect({ hasCarter: false, carterCode: null })}
          className="mt-4 px-4 py-2 bg-red-500 text-white rounded-lg"
        >
          Continua
        </button>
      </div>
    );
  }

  return (
    <div className="text-center">
      <h2 className="text-xl font-bold mb-4">Seleziona il Tipo di Carter</h2>

      <div className="grid grid-cols-2 md:grid-cols-3 gap-4 mb-6">
        {validCarterCodes.map((code) => (
          <button
            key={code}
            onClick={() => handleCarterSelect(code)}
            className={`p-4 border rounded-lg ${selectedCode === code ? 'bg-red-100 border-red-500' : 'border-gray-300'
              }`}
          >
            <div className="flex flex-col items-center">
              <img
                src={getCarterImagePath(code)}
                alt={getCarterLabel(code)}
                className="w-24 h-24 object-contain mb-2"
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = '/images/placeholder.svg';
                }}
              />
              <span className="font-medium">{getCarterLabel(code)}</span>
            </div>
          </button>
        ))}

        {/* Option for no carter */}
        <button
          onClick={handleNoCarterSelect}
          className={`p-4 border rounded-lg ${selectedCode === null && state.orderDetails.hasCarter === false
            ? 'bg-red-100 border-red-500'
            : 'border-gray-300'
            }`}
        >
          <div className="flex flex-col items-center">
            <div className="w-24 h-24 flex items-center justify-center mb-2">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-16 w-16 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636" />
              </svg>
            </div>
            <span className="font-medium">Senza Carter</span>
          </div>
        </button>
      </div>
    </div>
  );
};

export default CarterSelector;
